import { LoadingButton } from '@mui/lab';
import { Alert, Box, Button, Grid, MenuItem, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, useMediaQuery } from '@mui/material';
import SimpleBarScroll from 'components/SimpleBar';
import SimpleBarHorizontal from 'components/SimpleBarHorizontal';
import { useFormik } from 'formik';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSmsServiceProviderThunk, updateSmsServiceProviderThunk } from 'store/reducers/third_party/smsProviderSlice';
import * as yup from "yup";

const validation = yup.object({
  name: yup.string().required("Name required"),
  code: yup.string().required("Code required"),
});
const dynamicFormInitials = {
  name: "",
  type: "text",
  required: false,
};
const SmsProviderCreate = ({item,fullGrid}) => {
  const dispatch = useDispatch()

  const { status } = useSelector((state) => state.smsProvider);
  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [credentialFormat, setCredentialFormat] = React.useState([]);
  const [showCredentialForm, setShowCredentialForm] = React.useState(false);
  const [dynamicFormState, setDynamicFormState] =
    React.useState(dynamicFormInitials);
  const [dynamicFormErrors, setDynamicFormErrors] = React.useState({});

  const handleFormChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setDynamicFormState({ ...dynamicFormState, [name]: value });
  };

  const formik = useFormik({
    initialValues: {
      name: item?.name ?? "",
      code: item?.code ?? "",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      const newData = { ...data, credential_format: credentialFormat };

      console.log(newData);
      if (item) {
        dispatch(updateSmsServiceProviderThunk({ id: item.id, data: newData }));
      } else {
        dispatch(createSmsServiceProviderThunk(newData));
      }
    },
    validateOnChange: false,
  });

  useEffect(() => {
    if (status?.error === "create" || status?.error === "update") {
      Object.keys(status?.errorMessage).forEach((key) => {
        console.log(key, status?.errorMessage?.create[key][0]);
        formik.setFieldError(key, status?.errorMessage?.create[key][0]);
      });
    }
  }, [status]);

  const removeCredentialFormat = (i) => {
    setCredentialFormat((state) => state.filter((item, index) => index !== i));
  };

  const addCredentialItem = (data) => {
    if (data.name) {
      setDynamicFormErrors({});
      setCredentialFormat([...credentialFormat, data]);
    } else {
      setDynamicFormErrors({ name: "Field required" });
    }
  };

  useEffect(() => {
    if (item) {
      setCredentialFormat(item.credential_format);
    }
  }, [item]);

  return (
    <>
      <SimpleBarScroll>
        <form onSubmit={formik.handleSubmit}>
          <Grid container columnSpacing={2} rowSpacing={0}>
            <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
              <TextField
                label="Name"
                variant="outlined"
                name="name"
                fullWidth
                sx={{ mt: 3 }}
                value={formik.values.name}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.name)}
                helperText={formik.errors.name}
                autoComplete="new-password"
                required
              />
            </Grid>
            
            <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
              <TextField
                label="Code"
                variant="outlined"
                name="code"
                fullWidth
                sx={{ mt: 3 }}
                value={formik.values.code}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.code)}
                helperText={formik.errors.code}
                autoComplete="new-password"
                required
              />
            </Grid>
          </Grid>
          <Stack direction="column" sx={{mt:2}}>
            <Button
              variant="outlined"
              onClick={() => setShowCredentialForm((state) => !state)}
              sx={{ width: 200 }}
            >
              {showCredentialForm
                ? "Hide credential form"
                : "show credential form"}
            </Button>
            {credentialFormat?.length > 0 && showCredentialForm && (
              <SimpleBarHorizontal>
                <Box
                  sx={{
                    backgroundColor: "#e7ebf0",
                    borderRadius: 2,
                    flex: 1,
                    mt: 2,
                  }}
                  padding={1}
                >
                  <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ minWidth: 100 }}>Name</TableCell>
                          <TableCell align="center" sx={{ minWidth: 80 }}>
                            Type
                          </TableCell>
                          <TableCell align="center" sx={{ minWidth: 80 }}>
                            Required
                          </TableCell>
                          <TableCell>&nbsp;</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {credentialFormat.map((cred, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {cred.name}
                            </TableCell>
                            <TableCell align="center">{cred.type}</TableCell>
                            <TableCell align="center">
                              {cred.required ? "Yes" : "No"}
                            </TableCell>

                            <TableCell align="center">
                              <LoadingButton
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  removeCredentialFormat(index);
                                }}
                              >
                                Delete
                              </LoadingButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </SimpleBarHorizontal>
            )}

            {showCredentialForm && (
              <Grid container columnSpacing={2} rowSpacing={2}>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField
                    label="Name"
                    variant="outlined"
                    name="name"
                    fullWidth
                    sx={{ mt: 2 }}
                    value={dynamicFormState?.name}
                    onChange={handleFormChange}
                    autoComplete="new-password"
                    error={Boolean(dynamicFormErrors?.name)}
                    helperText={dynamicFormErrors?.name}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField
                    label="Type"
                    variant="outlined"
                    name="type"
                    select
                    fullWidth
                    sx={{ mt: 2 }}
                    value={dynamicFormState?.type}
                    error={Boolean(dynamicFormErrors?.type)}
                    helperText={dynamicFormErrors?.type}
                    onChange={handleFormChange}
                    autoComplete="new-password"
                    required
                  >
                    <MenuItem value="text">Text</MenuItem>
                    <MenuItem value="number">Number</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField
                    label="Required"
                    variant="outlined"
                    name="required"
                    select
                    fullWidth
                    sx={{ mt: 2 }}
                    value={dynamicFormState?.required}
                    onChange={handleFormChange}
                    autoComplete="new-password"
                    error={Boolean(dynamicFormErrors?.required)}
                    helperText={dynamicFormErrors?.required}
                  >
                    <MenuItem value={true}>Yes</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      addCredentialItem(dynamicFormState);
                      
                    }}
                    sx={{ mt: 2 }}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            )}

            {((!item && status?.error === "create") ||
              (item  && status?.error === "update")) && (
              <Alert sx={{ my: 1 }} severity="error">
                Error occurred
              </Alert>
            )}

            {((!item  && status?.success === "create") ||
              (item  && status?.success === "update")) && (
              <Alert sx={{ my: 1 }} severity="success">
                Success
              </Alert>
            )}
            <LoadingButton
              loading={
                (!item && status?.loading === "create") ||
                (item && status?.loading === "update")
              }
              variant="contained"
              fullWidth={isFullWidth}
              type="submit"
              sx={{ paddingX: 10, marginTop: 1, width: 200 }}
            >
              {item ? "Update" : "Create"}
            </LoadingButton>
          </Stack>
        </form>
      </SimpleBarScroll>
      
    </>
  )
}

export default SmsProviderCreate